import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import PropTypes from "prop-types";
import Header from "../Templates/Header";

const SectionNavigation = (props) => {
  // const { doc } = props;
  let siteSettings = null;

  const siteData = useStaticQuery(graphql`
    {
      storyblokEntry(slug: { eq: "settings" }) {
        content
      }
    }
  `);

  siteSettings = JSON.parse(siteData.storyblokEntry.content);
  return <Header settings={siteSettings} />;
};

export default SectionNavigation;

SectionNavigation.propTypes = {
  doc: PropTypes.object,
};

SectionNavigation.defaultProps = {
  doc: null,
};
